import { useState } from 'react';
import FormGroup from '../../../../components/bootstrap/forms/FormGroup';
import { Dropdown } from 'react-bootstrap';
import { useIncomes } from '../provider/IncomesProvider';
import { RootState } from '../../../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import CustomDateRangePicker, { RangeDate } from '../../../../components/CustomDateRangePicker';
import moment from 'moment';
import { changeIncomeFilters } from '../../../../redux/schedulerSlice';
import Button from '../../../../components/bootstrap/Button';

const IncomesFilters = () => {

    //  Redux connection
    const dispatch = useDispatch();
    const incomeFilters = useSelector((state: RootState) => state.scheduler.incomeFilters);
    const { filters, updateFilters, viewMode, changeViewMode } = useIncomes();

    const [fromDate, setFromDate] = useState<string>(filters.filter_filters?.estimated_entry_date?.from || incomeFilters.estimated_entry_date.from);
    const [toDate, setToDate] = useState<string>(filters.filter_filters?.estimated_entry_date?.to || incomeFilters.estimated_entry_date.to);
    const [selectedOption, setSelectedOption] = useState(viewMode);
    const options = ['Mes', 'Semana', 'Día'];

    const handleViewModeChange = (eventKey: any) => {
        setSelectedOption(eventKey);
        changeViewMode(eventKey);
        switch (eventKey) {
            case 'Mes':
                updateFilters({ range_mode_view: 'month' });
                break;
            case 'Semana':
                updateFilters({ range_mode_view: 'week' });
                break;
            case 'Día':
                updateFilters({ range_mode_view: 'day' });
                break;
        }
    };

    /**
    * Update the date range filter
    */
    const onChangeDateUpdate = (range: RangeDate) => {
        if (range.startDate && range.endDate) {
            // Update the calendar
            setFromDate(moment(range.startDate).format('YYYY-MM-DD'));
            setToDate(moment(range.endDate).format('YYYY-MM-DD'));

            // Update filters
            updateFilters({
                estimated_entry_date: {
                    from: moment(range.startDate).format('YYYY-MM-DD'),
                    to: moment(range.endDate).format('YYYY-MM-DD')
                }
            });

            // Update redux
            dispatch(changeIncomeFilters({
                estimated_entry_date: {
                    from: moment(range.startDate).format('YYYY-MM-DD'),
                    to: moment(range.endDate).format('YYYY-MM-DD')
                }
            }));
        }
    };

    return (
        <div className='row w-100 d-flex justify-content-end'>
            <FormGroup className='d-flex align-items-center col-5'>
                <CustomDateRangePicker
                    defaultSelection='custom'
                    showStaticRanges={true}
                    onChangeDate={onChangeDateUpdate}
                    customSelection={{
                        startDate: fromDate ? moment(fromDate).toDate() : moment().startOf('month').toDate(),
                        endDate: toDate ? moment(toDate).toDate() : moment().endOf('day').toDate()
                    }}
                />
            </FormGroup>

            <FormGroup className='d-flex align-items-center col-2'>
                <Dropdown onSelect={handleViewModeChange}>
                    <Dropdown.Toggle variant="primary" id="dropdown-basic" style={{ paddingRight: '10px', paddingLeft: '10px', marginLeft: 'auto', marginRight: '-60px' }}>
                        {selectedOption}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        {options.map((option) => (
                            <Dropdown.Item key={option} eventKey={option}>
                                {option}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            </FormGroup>

            <FormGroup className='d-flex align-items-center col-2'>
                <Button
                    color='brand'
                    onClick={() => {
                        updateFilters({ estimated_entry_date: { from: moment().subtract(2, 'months').format('YYYY-MM-DD'), to: moment().add(2, 'months').format('YYYY-MM-DD') } });
                        dispatch(changeIncomeFilters({ estimated_entry_date: { from: moment().subtract(2, 'months').format('YYYY-MM-DD'), to: moment().add(2, 'months').format('YYYY-MM-DD') } }));
                    }}
                >
                    Limpiar
                </Button>
            </FormGroup>
        </div>
    );
}

export default IncomesFilters;